import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import ViewBanner from './components/ViewBanner.vue';
import ViewNav from './components/ViewNav.vue';
import ViewIntro from './components/ViewIntro.vue';
import ViewSchedule from './components/ViewSchedule.vue';
import ViewGuest from './components/ViewGuest.vue';
import ViewGuide from './components/ViewGuide.vue';
import ViewJoin from './components/ViewJoin.vue';
import { homeUsingGET_1 } from '@/service/apiService';
import { actId } from '@/utils/const';

var Home = /*#__PURE__*/function (_Vue) {
  _inherits(Home, _Vue);

  var _super = _createSuper(Home);

  function Home() {
    var _this;

    _classCallCheck(this, Home);

    _this = _super.apply(this, arguments);
    _this.homeData = {};
    return _this;
  }

  _createClass(Home, [{
    key: "created",
    value: function () {
      var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return homeUsingGET_1({
                  actId: actId
                });

              case 2:
                data = _context.sent;
                this.homeData = data.data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }]);

  return Home;
}(Vue);

Home = __decorate([Component({
  components: {
    ViewBanner: ViewBanner,
    ViewNav: ViewNav,
    ViewIntro: ViewIntro,
    ViewSchedule: ViewSchedule,
    ViewGuest: ViewGuest,
    ViewGuide: ViewGuide,
    ViewJoin: ViewJoin
  }
})], Home);
export default Home;